import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import b from 'b_';
import TextStore from '../../stores/helpers/TextStore';
import BrowserStore from '../../browser/stores/BrowserStore';
import FuseBrowserModal from '../BrowserModal/FuseBrowserModal';
import BrowserPopUp from '../BrowserPopUp/BrowserPopUp';
import { Card } from '../Fuse';
import Accordion from '../Accordion/Accordion';
import FuseAlert from '../FuseControls/FuseAlert';
import FuseButton from '../FuseControls/FuseButton';
import FuseCheckbox from '../FuseControls/FuseCheckbox';
import { ObservableFuseSelect } from '../FuseControls/FuseSelect';
import FuseTextArea from '../FuseControls/FuseTextArea';
import FuseTextfield from '../FuseControls/FuseTextfield';
import SnackStore from '../../stores/SnackStore';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import OldSendFeedbackModal from './oldSendFeedbackModal';
import * as Text from '../Fuse/Text';
import './SendFeedbackModal.css';

const block = b.lock('NewSendFeedbackModal');

class NewSendFeedbackModal extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        browser: BrowserStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };


    componentDidMount() {
        this.props.browser.sendFeedbackStore.type.setOptions([
            { value: 'Feature Suggestion', label: this.props.t('feedbackTypes.featureSuggestion') },
            { value: 'General Feedback', label: this.props.t('feedbackTypes.generalFeedback') },
            { value: 'Website Is Not Working', label: this.props.t('feedbackTypes.websiteIsNotWorking') },
        ]);
    }

    getString = (suffixKeyName) => {
        const prefix = this.props.browser.sendFeedbackStore.isCustomerSupport
            ? 'sendFeedbackModal.customerSupport.'
            : 'sendFeedbackModal.';
        return this.props.t(prefix + suffixKeyName);
    };

    onSend = (event) => {
        event.preventDefault();

        const { browser, snack } = this.props;

        browser.sendFeedbackStore.debugData = browser.getDiagnostics();
        browser.sendFeedbackStore.sendFeedback()
            .then(() => {
                if (browser.sendFeedbackStore.isCustomerSupport) {
                    browser.setTroubleshootingMode(false);
                }
            })
            .catch((e) =>
                snack.showError(`${this.getString('sendFailureMessage')} ${e && e.message || ''}`));
    };

    onExitConfirm = () => {
        const { browser } = this.props;

        browser.sendFeedbackStore.clearAndCloseModal();
        if (browser.sendFeedbackStore.isCustomerSupport) {
            browser.setTroubleshootingMode(false);
        }
    };

    onExitConfirmationClose = () => {
        const { sendFeedbackStore } = this.props.browser;

        if (sendFeedbackStore.isCustomerSupport) {
            sendFeedbackStore.modal.close();
        } else {
            sendFeedbackStore.exitConfirmationModal.close();
        }
        sendFeedbackStore.exitConfirmationCheckbox.close();
    };

    onExitConfirmationConfirm = () => {
        const { sendFeedbackStore } = this.props.browser;

        this.onExitConfirm();
        sendFeedbackStore.exitConfirmationCheckbox.close();
        sendFeedbackStore.exitConfirmationModal.close();
    };

    onExitConfirmationCancel = () => {
        this.onExitConfirmationClose();
    };

    renderBrowserState() {
        const debugData = this.props.browser.getDiagnostics();

        if (!debugData) {
            return <div className={block('DataTitle')}>No browser state from server.</div>;
        }

        return <code className={block('DebugData')}>
            {JSON.stringify(debugData, null, 4)}
        </code>;
    }

    getInvalidEmailError() {
        const { email } = this.props.browser.sendFeedbackStore;

        if (email.hasChanged() && !email.isValid()) {
            return this.getString('invalidEmailMessage');
        }

        return '';
    }

    renderWarning(withBottomMargin = true) {
        return <FuseAlert
            className={withBottomMargin ? block('Field') : ''}
            type="info"
        >{this.getString('remarkMessageV2')}</FuseAlert>;
    }

    handleBack = () => {
        const { browser } = this.props;
        browser.sendFeedbackStore.closeModal();
        browser.topBarMenu.open();
    };

    render() {
        const { browser } = this.props;
        const { sendFeedbackStore } = browser;

        return <Fragment>
            <FuseBrowserModal
                isOpen={sendFeedbackStore.modal.isOpen}
                onClose={sendFeedbackStore.closeModal}
                onBack={this.handleBack}
                title={this.getString('title')}
                style={{ content: { width: '100%', maxWidth: 620 } }}
                footerActions={<>
                    <FuseButton
                        style={{ minWidth: 100, marginLeft: 10 }}
                        onClick={sendFeedbackStore.closeModal}
                        color="blue"
                        type="tertiary"
                        qa="send-feedback-modal-cancel"
                    >{this.getString('canselButton')}</FuseButton>
                    <FuseButton
                        style={{ minWidth: 100 }}
                        disabled={!sendFeedbackStore.isValid()}
                        loading={sendFeedbackStore.sendStatus.isLoading}
                        onClick={this.onSend}
                        color="blue"
                        qa="send-feedback-modal-send"
                    >{this.getString('sendFeedbackButton')}</FuseButton>
                </>}
            >
                <Card>
                    {sendFeedbackStore.isCustomerSupport ? <>
                        <FuseTextfield
                            className={block('Field')}
                            label={this.getString('caseId')}
                            store={new TextStore(browser.troubleshootingCaseId)}
                            disabled
                            qa="send-feedback-modal-troubleshooting-case-id"
                        />
                        <FuseTextfield
                            className={block('Field')}
                            label={`${this.getString('emailLabel')} ${this.getString('required')}`}
                            placeholder={this.getString('emailPlaceholder')}
                            store={sendFeedbackStore.email}
                            error={!!this.getInvalidEmailError()}
                            bottomText={this.getInvalidEmailError()}
                            qa="send-feedback-modal-email"
                        />
                    </> : <>
                        {this.renderWarning()}
                        <ObservableFuseSelect
                            containerClassName={block('Field', { select: true })}
                            singleSelection
                            selectLabel={this.getString('selectTypeLabel')}
                            placeholder={this.getString('selectTypePlaceholder')}
                            store={sendFeedbackStore.type}
                            lowOpacity={sendFeedbackStore.type.selectedValues.length === 0}
                            qa="send-feedback-modal-type-select"
                        />
                    </>}
                    <FuseTextArea
                        store={sendFeedbackStore.comment}
                        label={`${this.getString('commentLabel')} ${this.getString('required')}`}
                        placeholder={this.getString('commentPlaceholder')}
                        qa="send-feedback-modal-comment"
                    />
                </Card>
                <div className={block('AccordionContainer')}>
                    <Accordion
                        flagStore={this.props.browser.sendFeedbackDataAccordion}
                        label={this.getString('recordedDataButtonV2')}
                        className={block('Accordion')}
                        labelClassName={block('AccordionLabel', {
                            expanded: this.props.browser.sendFeedbackDataAccordion.getValue()
                        })}
                        iconClassName={block('AccordionIcon')}
                        contentClassName={block('AccordionContent')}
                        qa="send-feedback-modal-data"
                        usePlusIcon
                    >{this.renderBrowserState()}</Accordion>
                </div>
            </FuseBrowserModal>

            <BrowserPopUp
                isOpen={sendFeedbackStore.exitConfirmationModal.isOpen}
                onClose={this.onExitConfirmationClose}
                title={this.getString('exitConfirmationModal.title')}
                footerActions={
                    <>
                        <FuseButton
                            type={'secondary'}
                            color={sendFeedbackStore.isCustomerSupport ? 'red' : 'blue'}
                            disabled={sendFeedbackStore.isCustomerSupport
                                && !sendFeedbackStore.exitConfirmationCheckbox.getValue()}
                            onClick={this.onExitConfirmationConfirm}
                            qa="exit-confirmation-modal-confirm"
                        >
                            {this.getString('exitConfirmationModal.confirmButton')}
                        </FuseButton>
                        <FuseButton
                            type={'primary'}
                            color={'blue'}
                            disabled={sendFeedbackStore.isCustomerSupport
                                && sendFeedbackStore.exitConfirmationCheckbox.getValue()}
                            onClick={this.onExitConfirmationCancel}
                            qa="exit-confirmation-modal-cancel"
                        >
                            {this.getString('exitConfirmationModal.cancelButton')}
                        </FuseButton>
                    </>
                }
            >
                <Text.FTBody>
                    {this.getString('exitConfirmationModal.body')}
                </Text.FTBody>
                {sendFeedbackStore.isCustomerSupport && (
                    <FuseCheckbox
                        store={sendFeedbackStore.exitConfirmationCheckbox}
                        label={this.getString('exitConfirmationModal.confirmCheckBox')}
                        qa="exit-confirmation-modal-checkbox"
                    />
                )}
            </BrowserPopUp>
            <BrowserPopUp
                isOpen={sendFeedbackStore.submitModal.getValue()}
                onClose={sendFeedbackStore.submitModal.close}
                title={this.getString('submitModal.title')}
                footerActions={
                    <>
                        <FuseButton
                            type={'primary'}
                            color={'blue'}
                            onClick={sendFeedbackStore.submitModal.close}
                        >
                            {this.getString('submitModal.closeButton')}
                        </FuseButton>
                    </>
                }
            >
                <Text.FTBody>
                    {this.getString('submitModal.message')}
                </Text.FTBody>
                {!sendFeedbackStore.isCustomerSupport && this.renderWarning(false)}
            </BrowserPopUp>
        </Fragment>;
    }
}

const WrappedNewSendFeedbackModal = translate()(inject('browser', 'snack')(observer(NewSendFeedbackModal)));

const SendFeedbackModal = () => {
    return isFuse5Enabled() ? <WrappedNewSendFeedbackModal /> : <OldSendFeedbackModal />;
};

export default SendFeedbackModal;
